import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { onChangeAdditionalCategory, onChangeExcludedService, onSelectCategory, onSelectSubCategory } from '../../features/appSlice';

const BusinessCategory = (props) => {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();


    const handleCategoryChecked = (event, categoryId) => {
        dispatch(onSelectCategory([categoryId, event.target.checked]));
    }

    const handleSubCategoryChecked = (event, subCategoryId, categoryId) => {
        dispatch(onSelectSubCategory([subCategoryId, categoryId]));
    }

    const handleAdditionalCategories = (e) => {
        dispatch(onChangeAdditionalCategory(e.target.value));
    }

    const handleExcludedService = (e, id) => {
        dispatch(onChangeExcludedService([id, e.target.value]))
    }
    return (
        <div className={`tab-pane fade ${(props.activeTab === 6) && 'show active'}`} id="businesscategory" role="tabpanel" aria-labelledby="businesscategory-tab">
            <div className='col-md-12'>
                <div className='row'>
                    <label className='fw-bold'>Which category does your company fall into?</label>
                    {state.app.contextData.categories.map((item) => (
                        <div className='col-md-6' key={item.id}>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id={`flexCheckDefault_${item.id}`}
                                    onChange={(e) => handleCategoryChecked(e, item.id)}
                                    checked={state.app.selectedCategory.includes(item.id) ? true : false}
                                />
                                <label className="form-check-label" htmlFor={`flexCheckDefault_${item.id}`}>
                                    {item.name}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
                {state.app.subcategoryListByCategory.length > 0 &&
                    <div className='row mt-4'>
                        <lable className='fw-bold mb-2'>Which service categories do you offer?</lable>
                        {state.app.subcategoryListByCategory.map((item) => (
                            <div className='col-md-6' key={item.id}>
                                <div className="form-check">
                                    <input
                                        checked={item.checked ? item.checked : false}
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id={`flexCheckDefault_${item.id}`}
                                        onChange={(e) => handleSubCategoryChecked(e, item.id, item.cat_id)}
                                    />
                                    <label className="form-check-label" htmlFor={`flexCheckDefault_${item.id}`}>
                                        {item.name}
                                    </label>
                                </div>
                                {/* {item.checked &&
                                    <div className='form-group pl-4'>
                                        <label style={{ fontSize: 12 }}>Any services within {item.name} that you want to exclude</label>
                                        <input 
                                            type="text" 
                                            className='form-control' 
                                            value={item.excludedServices} 
                                            onChange={(e) => handleExcludedService(e, item.id)}
                                        />
                                    </div>
                                } */}
                            </div>
                        ))}
                    </div>
                }
                <div className='mt-4'>
                    <div className='form-group'>
                        <label className='fw-bold mb-2'>If you want to exclude other actions, go ahead and write them below. We suggest that you start each exclusion with “Don’t.” For example, “Don’t give pricing in the chat.”</label>
                        <textarea 
                            className='form-control' 
                            rows={4} 
                            value={state.app.contextData.business_categories.additionCategories}
                            onChange={(e) => handleAdditionalCategories(e)}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessCategory